import React, { useState } from 'react';
import PDFPopup from './PDFPopup'; // your popup component

function UserManualSection({ filteredMaterials, selectedGroup }) {
  
  const [showAll, setShowAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  if (selectedGroup <= 0) return null; // don't render if group not > 1

  const documents = filteredMaterials.filter(
    (material) => material.contentType === 'Document'
  );

  const displayedDocuments = showAll ? documents : documents.slice(0, 3);

  const openPopup = (material) => {
    setSelectedMaterial(material);
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    setSelectedMaterial(null);
  };

  return (
   <div className="bg-[#EBE7D8]/50 p-4 rounded-2xl">
 <div className="flex">
    <h1 className="text-xl font-bold text-primary-500 pb-4 grow">User Manual</h1>
 
  
     <div>
      {documents.length > 3 && (
      <button
        onClick={() => setShowAll(!showAll)}
        className="text-xl font-bold text-primary-500 pb-4 block hover:underline self-start"
      >
        {showAll ? 'View Less' : 'View More'}
      </button>
    )}
    </div>
  </div>

  <div className="flex flex-col gap-4">
    {/* Document List */}
    <div className="grid grid-flow-row gap-3">
      {displayedDocuments.map((material) => (
        <div
          key={material.trainingMaterialID}
          className="doc bg-[#EBE7D8]/70 p-2 flex rounded-lg gap-4 items-center cursor-pointer"
          onClick={() => openPopup(material)}
        >
          <img className="w-10" src="images/pdf.svg" alt="PDF Icon" />
          <label className="text-primary-500 font-bold text-base">
            {material.materialName}
          </label>
        </div>
      ))}
    </div>

    {/* View More / View Less button BELOW */}
   
  </div>

  {/* PDF Popup */}
  {isOpen && selectedMaterial?.contentType === 'Document' && (
    <PDFPopup
      fileUrl={selectedMaterial.fileUrl}
      title={selectedMaterial.materialName}
      onClose={closePopup}
    />
  )}
</div>

  );
}

export default UserManualSection;
